import history from '../../history';

import axios from "../../axios/axios";

import * as apis from "../../apis";
import * as routes from "../../routes";
import * as errors from "../../errors"
import * as successes from "../../successes"

import { notifyError, notifySuccess } from "../../toast-notifications";

import { getAxiosTokenConfig } from "../../helpers";


// LOGIN ACTIONS
export const LOGIN_REQUEST = "LOGIN_REQUEST";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_ERROR = "LOGIN_ERROR";

export function loginRequest() {
    return {
        type: LOGIN_REQUEST,
        loading: true
    };
}

export function loginError(error) {
    return {
        type: LOGIN_ERROR,
        loading: false,
        error
    };
}

export function loginSuccess(payload) {
    return {
        type: LOGIN_SUCCESS,
        loading: false,
        error: null,
        payload,
    };
}

export function login(email, password) {
    return dispatch => {
        dispatch(loginRequest());

        const data = {
            username: email,
            password: password
        };

        axios.post(apis.LOGIN_API, data)
            .then(response => {
                localStorage.setItem("token", response.data.token);
                localStorage.setItem("expiration", response.data.expiration);
                dispatch(loginSuccess(response.data));
            })
            .catch(error => {
                let error_message = errors.LOGIN_UNKNOWN_ERROR;
                switch (error.response?.status) {
                    case 400:
                        error_message = errors.LOGIN_BAD_CREDENTIALS_ERROR
                        break;
                    case 500:
                        error_message = errors.LOGIN_BAD_SERVER_ERROR
                        break;
                    default:
                        break;
                }
                dispatch(loginError(error_message));
                notifyError(error_message);
            });
    }
}

// LOGOUT ACTIONS
export const LOGOUT_REQUEST = "LOGOUT_REQUEST";
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
export const LOGOUT_ERROR = "LOGOUT_ERROR";

export function logoutRequest() {
    return {
        type: LOGOUT_REQUEST,
        loading: true
    };
}

export function logoutError(error) {
    return {
        type: LOGOUT_ERROR,
        loading: false,
        error
    };
}

export function logoutSuccess() {
    return {
        type: LOGOUT_SUCCESS,
        loading: false,
        error: null,
    };
}

export function logout() {
    return dispatch => {
        dispatch(logoutRequest());
        axios.post(apis.LOGOUT_API, {}, getAxiosTokenConfig())
            .then(response => {
                localStorage.setItem("token", null);
                localStorage.setItem("expiration", null);
                dispatch(logoutSuccess());
            })
            .catch(error => {
                dispatch(logoutError(errors.LOGOUT_ERROR));
                notifyError(errors.LOGOUT_ERROR);
            });
    }
}

// RESET PASSWORD EMAIL ACTIONS
export const RESET_PASSWORD_EMAIL_REQUEST = "RESET_PASSWORD_EMAIL_REQUEST";
export const RESET_PASSWORD_EMAIL_SUCCESS = "RESET_PASSWORD_EMAIL_SUCCESS";
export const RESET_PASSWORD_EMAIL_ERROR = "RESET_PASSWORD_EMAIL_ERROR";

export function resetPasswordEmailRequest() {
    return {
        type: RESET_PASSWORD_EMAIL_REQUEST,
        loading: true
    };
}

export function resetPasswordEmailError(error) {
    return {
        type: RESET_PASSWORD_EMAIL_ERROR,
        loading: false,
        error
    };
}

export function resetPasswordEmailSuccess(payload) {
    return {
        type: RESET_PASSWORD_EMAIL_SUCCESS,
        loading: false,
        error: null,
        payload,
    };
}

export function resetPasswordEmail(email) {
    return dispatch => {
        dispatch(resetPasswordEmailRequest());

        const data = {
            email: email,
        };

        axios.post(apis.RESET_PASSWORD_EMAIL_API, data)
            .then(response => {
                dispatch(resetPasswordEmailSuccess(response.data));
                notifySuccess(successes.RESET_PASSWORD_EMAIL_SUCCESS);
            })
            .catch(error => {
                let error_message = errors.RESET_PASSWORD_EMAIL_UNKNOWN_ERROR;

                if (error.response) {
                    const status = error.response.status;
                    if (status >= 400 && status <= 499) {
                        error_message = errors.RESET_PASSWORD_EMAIL_USER_ERROR;
                    }
                }

                dispatch(resetPasswordEmailError(error_message));
                notifyError(error_message);
            });
    }
}


// RESET PASSWORD CONFIRM ACTIONS
export const RESET_PASSWORD_CONFIRM_REQUEST = "RESET_PASSWORD_CONFIRM_REQUEST";
export const RESET_PASSWORD_CONFIRM_SUCCESS = "RESET_PASSWORD_CONFIRM_SUCCESS";
export const RESET_PASSWORD_CONFIRM_ERROR = "RESET_PASSWORD_CONFIRM_ERROR";

export function resetPasswordConfirmRequest() {
    return {
        type: RESET_PASSWORD_CONFIRM_REQUEST,
        loading: true
    };
}

export function resetPasswordConfirmError(error) {
    return {
        type: RESET_PASSWORD_CONFIRM_ERROR,
        loading: false,
        error
    };
}

export function resetPasswordConfirmSuccess(payload) {
    return {
        type: RESET_PASSWORD_CONFIRM_SUCCESS,
        loading: false,
        error: null,
        payload,
    };
}

export function resetPasswordConfirm(token, password) {
    return dispatch => {
        dispatch(resetPasswordConfirmRequest());

        const data = {
            token: token,
            password: password
        };

        localStorage.removeItem('token');
        localStorage.removeItem('expiration');

        axios.post(apis.RESET_PASSWORD_CONFIRM_API, data)
            .then(response => {
                dispatch(resetPasswordConfirmSuccess(response.data));
                history.push(routes.LOGIN);
                notifySuccess(successes.RESET_PASSWORD_CONFIRM_SUCCESS);
            })
            .catch(error => {
                let error_message = errors.RESET_PASSWORD_CONFIRM_UNKNOWN_ERROR;

                if (error.response) {
                    const status = error.response.status;
                    if (status === 400) {
                        error_message = errors.RESET_PASSWORD_CONFIRM_ERROR;
                    }
                    else if (status === 500) {
                        error_message = errors.RESET_PASSWORD_CONFIRM_ERROR;
                    }
                }

                dispatch(resetPasswordConfirmError(error_message));
                notifyError(error_message);
            });
    }
}


// GET CONNECTED USER ACTIONS
export const GET_CONNECTED_USER_REQUEST = "GET_CONNECTED_USER_REQUEST";
export const GET_CONNECTED_USER_SUCCESS = "GET_CONNECTED_USER_SUCCESS";
export const GET_CONNECTED_USER_ERROR = "GET_CONNECTED_USER_ERROR";

export function getConnectedUserRequest() {
    return {
        type: GET_CONNECTED_USER_REQUEST,
        loading: true
    };
}

export function getConnectedUserError(error) {
    return {
        type: GET_CONNECTED_USER_ERROR,
        loading: false,
        error
    };
}

export function getConnectedUserSuccess(payload) {
    return {
        type: GET_CONNECTED_USER_SUCCESS,
        loading: false,
        error: null,
        payload,
    };
}

export function getConnectedUser() {
    return dispatch => {
        dispatch(getConnectedUserRequest());

        axios.get(apis.GET_CONNECTED_USER_API, getAxiosTokenConfig())
            .then(response => {
                dispatch(getConnectedUserSuccess(response.data));
            })
            .catch(error => {
                let error_message = errors.GET_CONNECTED_USER_UNKNOWN_ERROR;

                if (error.response) {
                    const status = error.response.status;

                    switch (status) {
                        case 401:
                            error_message = errors.GET_CONNECTED_USER_NOT_CONNECTED_ERROR;
                            break;

                        case 500:
                            error_message = errors.GET_CONNECTED_USER_BAD_SERVER_ERROR;
                            break;
                        default:
                            break;
                    }
                }

                dispatch(getConnectedUserError(error_message));
            });
    }
}

// GET USER SETTINGS
export const GET_USER_SETTINGS_REQUEST = "GET_USER_SETTINGS_REQUEST";
export const GET_USER_SETTINGS_SUCCESS = "GET_USER_SETTINGS_SUCCESS";
export const GET_USER_SETTINGS_ERROR = "GET_USER_SETTINGS_ERROR";

export function getUserSettingsRequest() {
    return {
        type: GET_USER_SETTINGS_REQUEST,
        loading: true
    };
}

export function getUserSettingsError(error) {
    return {
        type: GET_USER_SETTINGS_ERROR,
        loading: false,
        error
    };
}

export function getUserSettingsSuccess(userSettings) {
    return {
        type: GET_USER_SETTINGS_SUCCESS,
        loading: false,
        error: null,
        userSettings,
    };
}

export function getUserSettings() {
    return dispatch => {
        dispatch(getUserSettingsRequest());
        axios.get(apis.GET_USER_SETTINGS_API, getAxiosTokenConfig())
            .then(response => {
                dispatch(getUserSettingsSuccess(response.data));
            })
            .catch(error => {
                dispatch(getUserSettingsError(errors.GET_USER_SETTINGS_ERROR));
                notifyError(errors.GET_USER_SETTINGS_ERROR);
            });
    };
}

// UPDATE USER SETTINGS
export const UPDATE_USER_SETTINGS_REQUEST = "UPDATE_USER_SETTINGS_REQUEST";
export const UPDATE_USER_SETTINGS_SUCCESS = "UPDATE_USER_SETTINGS_SUCCESS";
export const UPDATE_USER_SETTINGS_ERROR = "UPDATE_USER_SETTINGS_ERROR";

export const updateUserSettingsRequest = () => {
    return {
        type: UPDATE_USER_SETTINGS_REQUEST,
        loading: true
    };
};
export const updateUserSettingsSuccess = (userSettings) => {
    return {
        type: UPDATE_USER_SETTINGS_SUCCESS,
        loading: false,
        error: null,
        userSettings
    };
};
export const updateUserSettingsError = (error) => {
    return {
        type: UPDATE_USER_SETTINGS_ERROR,
        loading: false,
        error
    };
};
export const updateUserSettings = (table) => {
    return dispatch => {
        dispatch(updateUserSettingsRequest());
        axios.patch(apis.UPDATE_USER_SETTINGS_API, table, getAxiosTokenConfig())
            .then(response => {
                dispatch(updateUserSettingsSuccess(response.data));
                notifySuccess(successes.UPDATE_USER_SETTINGS_SUCCESS);
            })
            .catch(error => {
                dispatch(updateUserSettingsError(error));
                notifyError(errors.UPDATE_USER_SETTINGS_ERROR);
            });
    };
};

// UPDATE USER PASSWORD
export const UPDATE_USER_PASSWORD_REQUEST = "UPDATE_USER_PASSWORD_REQUEST";
export const UPDATE_USER_PASSWORD_SUCCESS = "UPDATE_USER_PASSWORD_SUCCESS";
export const UPDATE_USER_PASSWORD_ERROR = "UPDATE_USER_PASSWORD_ERROR";

export const updateUserPasswordRequest = () => {
    return {
        type: UPDATE_USER_PASSWORD_REQUEST,
        loading: true
    };
};
export const updateUserPasswordSuccess = (payload) => {
    return {
        payload,
        type: UPDATE_USER_PASSWORD_SUCCESS,
        loading: false,
        error: null
    };
};
export const updateUserPasswordError = (error) => {
    return {
        type: UPDATE_USER_PASSWORD_ERROR,
        loading: false,
        error
    };
};
export const updateUserPassword = (password) => {
    return dispatch => {
        dispatch(updateUserPasswordRequest());

        return new Promise((resolve, reject) => {
            axios.post(apis.UPDATE_USER_PASSWORD_API, password, getAxiosTokenConfig())
                .then(response => {
                    localStorage.setItem("token", response.data.token);
                    localStorage.setItem("expiration", response.data.expiration);
                    dispatch(updateUserPasswordSuccess(response.data));
                    notifySuccess(successes.UPDATE_USER_PASSWORD_SUCCESS);
                    resolve();
                })
                .catch(error => {
                    dispatch(updateUserPasswordError(error));
                    notifyError(errors.UPDATE_USER_PASSWORD_ERROR);
                    reject();
                });
        });
    };
};


// ADD PUSH NOTIFICATION TOKEN
export const ADD_PUSH_NOTIFICATION_TOKEN_REQUEST = "ADD_PUSH_NOTIFICATION_TOKEN_REQUEST";
export const ADD_PUSH_NOTIFICATION_TOKEN_SUCCESS = "ADD_PUSH_NOTIFICATION_TOKEN_SUCCESS";
export const ADD_PUSH_NOTIFICATION_TOKEN_ERROR = "ADD_PUSH_NOTIFICATION_TOKEN_ERROR";

export function addPushNotificationTokenRequest() {
    return {
        type: ADD_PUSH_NOTIFICATION_TOKEN_REQUEST,
        loading: true
    };
}

export function addPushNotificationTokenError(error) {
    return {
        type: ADD_PUSH_NOTIFICATION_TOKEN_ERROR,
        loading: false,
        error
    };
}

export function addPushNotificationTokenSuccess(payload) {
    return {
        type: ADD_PUSH_NOTIFICATION_TOKEN_SUCCESS,
        loading: false,
        error: null,
        payload,
    };
}

export function addPushNotificationToken(pushToken) {
    return dispatch => {
        dispatch(addPushNotificationTokenRequest());

        const data = {
            token: pushToken
        };

        axios.post(apis.ADD_PUSH_NOTIFICATION_TOKEN_API, data, getAxiosTokenConfig())
            .then(response => {
                dispatch(addPushNotificationTokenSuccess(response.data));
            })
            .catch(error => {
                const status = error.response.status;
                let error_message = errors.ADD_PUSH_NOTIFICATION_TOKEN_ERROR;
                dispatch(addPushNotificationTokenError(error_message));
                notifyError(error_message);
            });
    }
}


// WEBPACK FOOTER //
// ./src/store/actions/authentication.js